import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Columns } from "../columns/colunms.entity";
import { Level } from "../level/level.entity";
import { Locations } from "../locations/location.entity";
import { RackZoneMapping } from "../rack-zone-mapping/rack-zone-mapping-entity";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";

@Entity('rm_zones')
export class RmZones {

  @PrimaryGeneratedColumn("increment", { name: 'rm_zone_id' })
  rmZoneId: number;

  @Column("char", {
    nullable: false,
    length: 20,
    name: "rm_zone_code"
  })
  @Index({ unique: true })
  rmZoneCode: string;
  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "rm_zone_name"
  })
  //   @Index({unique:true})
  rmZoneName: string;

  @Column('integer', {
    nullable: true,
    name: 'plant_id'
  })
  plantId: number;
 
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  
  @OneToMany(type => RmRack, rack => rack.rmZonesInfo, { cascade: true })
  rmRacksInfo: RmZones[];

}
